<template>
<div>

<div v-if="item">

    <h4 v-if="item.temp_name">{{item.temp_name}}</h4>

    <selector
          v-model="item.product"
          :title="`Группа`"
          :modal="`group`"
          :selectKey="`display_name`"
        />


       <h6>Модификация</h6>
        <hr/>

 

  <div v-if="item.product">


      
    <button class="btn btn-sm mb-4" @click="createNew = !createNew">
      <span v-if="createNew === false">
        <span class="ti-plus"></span> Новая модицикация</span
      >
      <span v-else> <span class="ti-arrow-left"></span> Отмена</span>
    </button>

    <modification
      @create="setModification"
      v-if="createNew === true"
      :product="item.product"
    />
    <div v-else>
      <div class="row">
        <div class="col-12">
          <select
            class="form-control mb-3"
            name=""
            id=""
            @change="changeModification"
          >
            <option
              v-for="modifiaction in item.product.modifications"
              :key="modifiaction.id"
              :value="modifiaction.id"
              :selected="modifiaction.id === item.id"
            >
              {{ modifiaction.display_name }}
            </option>
          </select>
        </div>
      </div>

      <hr />
  
      <fields-list :item="item" :fields="fields" />
        <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
    </div>
  </div>

  <div v-else>

      <h6>Чтобы модерировать товар, необходио установить группу</h6>
  <hr/>
  <p>Например: Выгрузился товар "iPhone 12 Pro 128 GB BLUE" - установить группу "Apple iPhone 12"</p>
  </div>
  
  </div>
</div>
</template>

<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

import FieldsList from "@/components/Card/FieldsList";
import selector from "@/components/Inputs/Selector";
import Modification from "@/components/Card/Product/Modification";

export default {
  data: () => ({
    product:null,
    createNew: false,
    cardLink: "products/card",
    cardSetLink: "products/update",
    item: null,
    fields: [
        {
        col: "col-md-6 col-12",
        label: "Бизнес",
        key: "business",
        type: "select",
        selectKey: "name",
        modal: "business",
      },
      {
        col: " col-12",
        key: "is_active",
        label: "Активность",
        type: "checkbox",
        textType: "text",
      },
      {
        col: " col-12",
        key: "is_confirmed",
        label: "Прошел модерацию",
        type: "checkbox",
        textType: "text",
      },
      {
        col: "col-md-6 col-12",
        key: "labels",
        selectKey: "title",
        label: "Тэги",
        type: "selects",
        modal: "label",
        prefix: "product",
      },

      {
        col: "col-md-6 col-12",
        label: "Цвет",
        key: "color",
        type: "select",
        selectKey: "title",
        modal: "color",
      },
      {
        col: "col-md-6 col-12",
        key: "name",
        label: "Название модели (уникальность)",
        type: "field",
        textType: "text",
      },
      {
        col: "col-md-6 col-12",
        key: "sku",
        label: "Баркод",
        type: "field",
        textType: "text",
      },
      {
        col: "col-md-4 col-12",
        key: "price",
        label: "Цена",
        type: "field",
        textType: "number",
      },
         {
          col: "col-md-4 col-12",
          key: "price_main",
          label: "Главная цена",
          type: "field",
          textType: "number",
        },
      {
        col: "col-md-4 col-12",
        key: "cashback_percent",
        label: "Процент кешбека (%)",
        type: "field",
        textType: "number",
      },
      {
        col: "col-md-4 col-12",
        key: "price_old",
        label: "Старая цена",
        type: "field",
        textType: "number",
      },
      {
        col: "col-md-4 col-12",
        key: "quantity",
        label: "Количество",
        type: "field",
        textType: "number",
      },
      {
        key: "title",
        label: "Доп название",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        key: "annotation",
        label: "Краткое описание",
        type: "textarea",
        isMultiLang: true,
      },
      {
        key: "body",
        label: "Полное описание",
        type: "html",
        isMultiLang: true,
      },
    ],
  }),
  components: {
    FieldsList,
    Modification,
    selector
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    updateItem() {
      this.cardUpdate(this.cardSetLink, this.item);
    },
    changeModification(e) {
      const id = e.target.value;
      this.setModification(id);
    },
    async setModification(id) {
      this.createNew = false;
      let query = Object.assign({}, this.$route.query);
      if (query["product"] == id) {
        return false;
      }
      if (query["product"]) {
        delete query["product"];
      }
      this.fields = [
        {
          col: " col-12",
          key: "is_active",
          label: "Активность",
          type: "checkbox",
          textType: "text",
        },

        {
          col: "col-md-6 col-12",
          key: "labels",
          selectKey: "title",
          label: "Тэги",
          type: "selects",
          prefix: "product",
          modal: "label",
        },

        {
          col: "col-md-6 col-12",
          label: "Цвет",
          key: "color",
          type: "select",
          selectKey: "title",
          prefix: "product",
          modal: "color",
        },
        {
          col: "col-md-6 col-12",
          key: "name",
          label: "Название модели (уникальность)",
          type: "field",
          textType: "text",
        },
        {
          col: "col-md-6 col-12",
          key: "sku",
          label: "Баркод",
          type: "field",
          textType: "text",
        },
        {
          col: "col-md-4 col-12",
          key: "price",
          label: "Цена",
          type: "field",
          textType: "number",
        },
        {
          col: "col-md-4 col-12",
          key: "price_main",
          label: "Главная цена",
          type: "field",
          textType: "number",
        },
        {
          col: "col-md-4 col-12",
          key: "cashback_percent",
          label: "Процент кешбека (%)",
          type: "field",
          textType: "number",
        },
        {
          col: "col-md-4 col-12",
          key: "price_old",
          label: "Старая цена",
          type: "field",
          textType: "number",
        },
        {
          col: "col-md-4 col-12",
          key: "quantity",
          label: "Количество",
          type: "field",
          textType: "number",
        },
        {
          key: "title",
          label: "Доп название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          key: "annotation",
          label: "Краткое описание",
          type: "textarea",
          isMultiLang: true,
        },
        {
          key: "body",
          label: "Полное описание",
          type: "html",
          isMultiLang: true,
        },
      ];
      query["product"] = id;
      this.item = null;
      this.item = await this.cardContent(this.cardLink, id);
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
};
</script>
<style>
</style>
